module.exports = __webpack_public_path__ + "img/img13.62107ef8.png";